import { IResourceComponentsProps } from '@pankod/refine-core';
import { getTrackSubscriptionPurchase } from 'apis/contributorSubscriptionPurchase';
import { useCallback, useEffect, useState } from 'react';
import 'react-mde/lib/styles/css/react-mde-all.css';
import { useParams } from 'react-router-dom';
import { formatDateTime } from 'utils';

export const SubscriptionPackagePurchasesShow: React.FC<IResourceComponentsProps> = () => {
    const { id } = useParams();
    const [tracks, setTracks] = useState<any>();
    const handleGetTrackSubscriptionPurchase = useCallback(async (id) => {
        const res = await getTrackSubscriptionPurchase(id);
        setTracks(res);
    }, []);

    useEffect(() => {
        if (id) {
            handleGetTrackSubscriptionPurchase(id);
        }
    }, [handleGetTrackSubscriptionPurchase, id]);

    return (
        <div style={{ marginTop: '20px' }}>
            <p style={{ fontWeight: 600, fontSize: '14px', color: '#000' }}>Total track: {tracks?.length || 0}</p>
            <p style={{ fontWeight: 600, fontSize: '14px', color: '#000' }}>Track detail:</p>
            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: '35px' }}>
                <p style={{ width: '16%', fontWeight: 500, color: '#000' }}>Date</p>
                <p style={{ width: '14%', fontWeight: 500, color: '#000' }}>Country</p>
                <p style={{ width: '14%', fontWeight: 500, color: '#000' }}>Label</p>
                <p style={{ width: '56%', fontWeight: 500, color: '#000' }}>Title</p>
            </div>
            {(tracks || []).map((item: any, index: any) => {
                return (
                    <div key={index} style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <p style={{ width: '16%' }}>{formatDateTime(item?.createdAt)}</p>
                        <p style={{ width: '14%' }}>{item?.country}</p>
                        <p style={{ width: '14%' }}>{item?.label?.name}</p>
                        <p style={{ width: '56%' }}>{item?.track?.title}</p>
                    </div>
                );
            })}
        </div>
    );
};
